import { combineReducers } from "@reduxjs/toolkit";

import { authSlice } from "../slices/authSlice";
import { tenantSlice } from "../slices/tenantSlice";

import processDetailsReducer from "../slices/processDetailsSlice";
import recruiterProfileReducer from "../slices/recruiterProfileSlice";
import liveInterviewReducer from "../slices/liveInterviewSlice";
import navigationSliceReducer from "../slices/navigationSlice";
import notificationsReducer from "../slices/notificationsSlice";
import copilotReducer from "../slices/copilotSlice";
import literalsReducer from "../slices/literalsSlice";
import literalsConfigurationReducer from "../slices/literalsConfigurationSlice";

export const rootReducer = combineReducers({
  processDetails: processDetailsReducer,
  tenant: tenantSlice.reducer,
  recruiterProfile: recruiterProfileReducer,
  liveInterview: liveInterviewReducer,
  auth: authSlice.reducer,
  notifications: notificationsReducer,
  navigation: navigationSliceReducer,
  copilot: copilotReducer,
  literals: literalsReducer,
  literalsConfiguration: literalsConfigurationReducer,
});
